import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
  otaList: [],
  otaDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  otasearchFilters: {
    searchText: "",
    typeActivityStatus: "",
  }
};
const otaSlice = createSlice({
  name: "ota",
  initialState: initialState,
  reducers: {
    otaListSuccess: (state, action) => {
      state.otaList = action.payload;
    },
    otaListFailed: (state, action) => {
      state.roomsList = [];
    },
    otaDatagridOptionsSucces: (state, action) => {
      state.otaDatagridOptions = {...state.otaDatagridOptions, [action.payload.key]: action.payload.value}
      },
      otasearchFiltersSucces: (state, action) => {
      state.otasearchFilters = {...state.otasearchFilters, [action.payload.key]: action.payload.value}
      },
  },
});

export const {
  otaListSuccess,
  otaListFailed,
  otaDatagridOptionsSucces,
  otasearchFiltersSucces,
} = otaSlice.actions;
export default otaSlice.reducer;
